import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
 selector: '[appPositiveNumber]'
})
export class PositiveNumberDirective {

 constructor(private el: ElementRef) { }

 @HostListener('input', ['$event']) onInputChange(event: Event) {
   const inputValue = this.el.nativeElement.value;
   const sanitizedValue = inputValue.replace(/[^0-9.:]/g, '');
   
   // Ensure only one decimal point
   const parts = sanitizedValue.split('.');
   if (parts.length > 2) {
     parts.splice(2);
   }
   
   this.el.nativeElement.value = parts.join('.');
   
   if (inputValue !== this.el.nativeElement.value) {
     event.stopPropagation();
   }
 }
}